import {
  LayoutDashboard,
  Users,
  Building2,
  Contact,
  TrendingUp,
  Briefcase,
  Kanban,
  Send,
  CalendarClock,
  FileText,
  Award,
  CheckCircle2,
  ListTodo,
  Calendar,
  Mail,
  DollarSign,
  BarChart3,
  Sparkles,
  UserCog,
  Workflow,
  Settings,
  HardHat,
  Clock,
  Target,
  ClipboardList,
  Search,
  MessageSquare,
  Inbox,
  Gauge,
  ListChecks,
  UserCheck,
  ShieldQuestion,
  RefreshCw,
  Tags,
  LayoutList,
  UsersRound,
  Download,
  HardDrive,
  Bell,
} from "lucide-react";

// Each item: label, path, icon, perm (any-of), section
export const NAV = [
  {
    label: "Command Center",
    path: "/",
    icon: LayoutDashboard,
    perm: null,
    section: "Overview",
  },
  {
    label: "BDM Command Center",
    path: "/bdm",
    icon: Target,
    perm: "dashboard:bdm",
    section: "BDM & Sales",
  },
  {
    label: "Sales Pipeline",
    path: "/sales",
    icon: TrendingUp,
    perm: "sales:view",
    section: "BDM & Sales",
  },
  {
    label: "R.A. Dashboard",
    path: "/ra",
    icon: LayoutDashboard,
    perm: "ra:desk",
    section: "R.A. Team Desk",
  },
  {
    label: "My Assigned Titles",
    path: "/ra/titles",
    icon: ClipboardList,
    perm: "ra:desk",
    section: "R.A. Team Desk",
  },
  {
    label: "Research Leads",
    path: "/ra/leads",
    icon: Search,
    perm: "ra:lead_manage",
    section: "R.A. Team Desk",
  },
  {
    label: "Duplicate Check",
    path: "/ra/duplicate-check",
    icon: ShieldQuestion,
    perm: "ra:lead_manage",
    section: "R.A. Team Desk",
  },
  {
    label: "Outreach",
    path: "/ra/outreach",
    icon: Send,
    perm: "ra:lead_manage",
    section: "R.A. Team Desk",
  },
  {
    label: "Replies",
    path: "/ra/replies",
    icon: MessageSquare,
    perm: "ra:lead_manage",
    section: "R.A. Team Desk",
  },
  {
    label: "Submitted for Review",
    path: "/ra/submitted",
    icon: Inbox,
    perm: "ra:lead_manage",
    section: "R.A. Team Desk",
  },
  {
    label: "My Targets",
    path: "/ra/targets",
    icon: Target,
    perm: "ra:desk",
    section: "R.A. Team Desk",
  },
  {
    label: "My Performance",
    path: "/ra/performance",
    icon: Gauge,
    perm: "ra:desk",
    section: "R.A. Team Desk",
  },
  {
    label: "Admin Review Queue",
    path: "/ra/review",
    icon: ListChecks,
    perm: "ra:admin_review",
    section: "R.A. Team Desk",
  },
  {
    label: "Title Assignment",
    path: "/ra/assign-titles",
    icon: UserCheck,
    perm: "ra:assign_titles",
    section: "R.A. Team Desk",
  },
  {
    label: "R.A. Team Performance",
    path: "/ra/team",
    icon: BarChart3,
    perm: "ra:team_view",
    section: "R.A. Team Desk",
  },
  {
    label: "R.A. Configuration",
    path: "/ra/config",
    icon: Settings,
    perm: "ra:config",
    section: "R.A. Team Desk",
  },
  {
    label: "R.A. Catalog Desk",
    path: "/ra/catalog",
    icon: Tags,
    perm: "ra:catalog_manage",
    section: "R.A. Team Desk",
  },
  {
    label: "R.A. Teams",
    path: "/ra/teams",
    icon: UsersRound,
    perm: "admin:manage_users",
    section: "R.A. Team Desk",
  },
  {
    label: "Dispatch Board",
    path: "/ra/dispatch",
    icon: LayoutList,
    perm: "ra:team_view",
    section: "R.A. Team Desk",
  },
  {
    label: "Google Sheets Sync Center",
    path: "/ra/sync",
    icon: RefreshCw,
    perm: "ra:config",
    section: "R.A. Team Desk",
  },
  {
    label: "Candidates",
    path: "/candidates",
    icon: Users,
    perm: "candidate:view",
    section: "Recruit",
  },
  {
    label: "Clients",
    path: "/clients",
    icon: Building2,
    perm: "client:view",
    section: "Recruit",
  },
  {
    label: "Contacts",
    path: "/contacts",
    icon: Contact,
    perm: "contact:view",
    section: "Recruit",
  },
  {
    label: "Jobs",
    path: "/jobs",
    icon: Briefcase,
    perm: "job:view",
    section: "Recruit",
  },
  {
    label: "Pipeline",
    path: "/pipeline",
    icon: Kanban,
    perm: "pipeline:view",
    section: "Recruit",
  },
  {
    label: "Submissions",
    path: "/submissions",
    icon: Send,
    perm: "submission:view",
    section: "Recruit",
  },
  {
    label: "Interviews",
    path: "/interviews",
    icon: CalendarClock,
    perm: "interview:view",
    section: "Recruit",
  },
  {
    label: "Offers",
    path: "/offers",
    icon: FileText,
    perm: "offer:view",
    section: "Recruit",
  },
  {
    label: "Placements",
    path: "/placements",
    icon: Award,
    perm: "placement:view",
    section: "Recruit",
  },
  {
    label: "Contractors",
    path: "/contractors",
    icon: HardHat,
    perm: "contractor:view",
    section: "Workforce",
  },
  {
    label: "Timesheets",
    path: "/timesheets",
    icon: Clock,
    perm: "timesheet:view",
    section: "Workforce",
  },
  {
    label: "Tasks",
    path: "/tasks",
    icon: ListTodo,
    perm: null,
    section: "Work",
  },
  {
    label: "Calendar",
    path: "/calendar",
    icon: Calendar,
    perm: null,
    section: "Work",
  },
  {
    label: "Revenue",
    path: "/revenue",
    icon: DollarSign,
    perm: "revenue:view",
    section: "Business",
  },
  {
    label: "Reports",
    path: "/reports",
    icon: BarChart3,
    perm: "reports:view",
    section: "Business",
  },
  {
    label: "Exports Center",
    path: "/exports",
    icon: Download,
    perm: "reports:export",
    section: "Business",
  },
  {
    label: "AI Intelligence",
    path: "/ai",
    icon: Sparkles,
    perm: "ai:access",
    section: "Business",
  },
  {
    label: "NEXREQ AI",
    path: "/nexreq-ai",
    icon: Sparkles,
    perm: null,
    section: "Work",
  },
  {
    label: "Nexreq AI Workspace",
    path: "/chatgpt",
    icon: MessageSquare,
    perm: "chatgpt:access",
    section: "Work",
  },
  {
    label: "Employees & HRMS",
    path: "/hrms",
    icon: UserCog,
    perm: "hrms:view",
    section: "Org",
  },
  {
    label: "Communications",
    path: "/communications",
    icon: Mail,
    perm: null,
    section: "Org",
  },
  {
    label: "Automations",
    path: "/automations",
    icon: Workflow,
    perm: "automation:view",
    section: "Org",
  },
  {
    label: "Team & Access",
    path: "/team-access",
    icon: UsersRound,
    perm: "admin:manage_users",
    roles: ["super_admin"],
    section: "Org",
  },
  {
    label: "NEXREQ Drive",
    path: "/nexreq-drive",
    icon: HardDrive,
    perm: "admin:manage_users",
    roles: ["super_admin", "founder"],
    section: "Org",
  },
  {
    label: "Notification Settings",
    path: "/notification-settings",
    icon: Bell,
    perm: "admin:manage_users",
    roles: ["super_admin", "founder"],
    section: "Org",
  },
  {
    label: "Administration",
    path: "/admin",
    icon: Settings,
    perm: "admin:access",
    section: "Org",
  },
];

export const SECTION_ORDER = [
  "Overview",
  "BDM & Sales",
  "R.A. Team Desk",
  "Recruit",
  "Workforce",
  "Work",
  "Business",
  "Org",
];
